import React from 'react';

function OgNameChips({ names }) {
  return (
    <div className="name-chips">
      {names.map((n, i) => (
        <span key={i} className="nc">
          {n}
        </span>
      ))}
    </div>
  );
}

export default OgNameChips;
